
    import { initNetworkStats } from "/js/network-stats.js";
    initNetworkStats();
  